type UpgradesSelected = number[] | undefined;

function any(list: number[] | undefined) {
    return list && list.length > 0;
}

export const anyUpgradesSelected = (
    accessories: UpgradesSelected,
    services?: UpgradesSelected,
    insurance?: UpgradesSelected
) => {
    return any(accessories) || any(services) || any(insurance);
};
